import {
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';

export const useTopStepProgressBarStyle = makeStyles({
  listContainer: {
    width: '100%',
    backgroundColor: tokens.colorNeutralBackground3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.gap('8px'),
    ...shorthands.borderBottom('1px', 'solid', tokens.colorNeutralStroke2),
    ...shorthands.overflow('auto', 'hidden'),
    ...shorthands.padding('12px', '24px'),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  parentStepTitle: {
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    ...shorthands.overflow('hidden'),
  },
  title: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    ...shorthands.overflow('hidden'),
  },
  tag: {
    backgroundColor: tokens.colorNeutralBackground1,
    '& span': {
      fontWeight: tokens.fontWeightSemibold,
      color: tokens.colorNeutralForeground3,
    },
  },
});
